import { Center, HStack, Image, Spacer, Spinner, Stack } from "@chakra-ui/react"
import { Button, Text } from "@/components"
import { useAuth } from "@/contexts"
import { useIsMobile } from "@/hooks"
import { NdaFormComponent } from "./components"

export const NdaComponent = () => {
  const { user, loading } = useAuth()
  const isMobile = useIsMobile()

  if (loading || !user) {
    return (
      <Center h="100vh" w="100%" bg="darkBlue.200">
        <Spinner color="white" />
      </Center>
    )
  }

  console.log("User:", user)
  if (user.userType !== "client") {
    console.log("User is not a client:", user)
    return null
  }

  if (!user.dealManager) {
    console.log("User does not have a deal manager assigned:", user)
    return null
  }

  return (
    <HStack bg="darkBlue.200">
      {!isMobile && (
        <Stack h="100vh" w="40%" p={10} bg="darkBlue.200">
          <Text fontSize="lg" fontWeight="bold" fontFamily="body" color="white" mb={10}>
            ESO Fund Client Portal
          </Text>
          <Text fontSize="xs" fontFamily="body" color="white">
            Your Equity Partner:
          </Text>
          <Text fontSize="3xl" fontWeight="bold" fontFamily="body" color="white">
            { `${user.dealManager.firstName} ${user.dealManager.lastName}` }
          </Text>
          <Image
            h="300px"
            w="300px"
            borderRadius={10}
            src={user.dealManager.profilePicture}
            alt="Equity Partner Profile Image"
          />
          <Spacer />
          <Button
            variant="outline"
            w="-webkit-fit-content"
            color="white"
            borderColor="white"
            _hover={{ bg: "whiteAlpha.200" }}
            onClick={() => window.open(user.dealManager.calendly, "_blank", "noopener,noreferrer")}
          >
            { `Schedule a call with ${user.dealManager.firstName}` }
          </Button>
        </Stack>
      )}
      <NdaFormComponent isInitialScreen={true} />
    </HStack>
  )
}
